import styles from './breadcrumb.module.css'

import clsx from 'clsx'

import { HistoryItem } from '@wartek-id/breadcrumb'
import { useMedia } from '@wartek-id/react-utils'

import { WILAYAH_NASIONAL } from '@/apis/data/statistik/wilayah'
import { District } from '@/apis/types'

import { Breadcrumbs } from '@/components/Breadcrumbs'

interface BreadcrumbDistrictProps {
  districts: District[]
  districtId: string
  districtLevel: number
  hrefBuilderFn: (district: District) => string
}

export function BreadcrumbDistrict({
  districts,
  districtId,
  districtLevel,
  hrefBuilderFn,
}: BreadcrumbDistrictProps) {
  const isMd = useMedia('(min-width: 768px)', false)

  const generateBreadcrumbItem = (district: District): HistoryItem => {
    const fullLink = hrefBuilderFn(district)

    return {
      href: fullLink,
      id: district?.id,
      text: district?.name,
    } as HistoryItem
  }

  const currentDistrict = districts.find((item) => item.id === districtId)
  const parentDistrict = districts.find(
    (item) => item.id === currentDistrict?.parentId
  )

  const breadcrumbNasional = generateBreadcrumbItem(WILAYAH_NASIONAL)
  const breadcrumbCurrent = currentDistrict
    ? generateBreadcrumbItem(currentDistrict)
    : null

  const breadcrumbParent = parentDistrict
    ? generateBreadcrumbItem(parentDistrict)
    : null

  const getBreadcrumbItems = (): HistoryItem[] => {
    if (districtLevel === 0) {
      return [breadcrumbNasional]
    }

    if (districtLevel === 1) {
      return [breadcrumbNasional, breadcrumbCurrent].filter(
        Boolean
      ) as HistoryItem[]
    }

    const withNasional = [
      breadcrumbNasional,
      breadcrumbParent,
      breadcrumbCurrent,
    ].filter(Boolean) as HistoryItem[]

    const withoutNasional = [breadcrumbParent, breadcrumbCurrent].filter(
      Boolean
    ) as HistoryItem[]

    return isMd ? withNasional : withoutNasional
  }

  return (
    <div
      className={clsx(
        'mb-4 rounded-md bg-white p-4 shadow',
        styles.breadcrumbDistrict
      )}
      data-testid="wrapper-breadcrumb"
    >
      <Breadcrumbs items={getBreadcrumbItems()} />
    </div>
  )
}
